import React from 'react'
import { AuthorizeAdminFlowMain } from './components/AuthorizeAdminFlowMain'
import { AuthorizeAdminFlowProvider } from './context/AuthorizeAdminFlowProvider'

export const AuthorizeAdminFlow = () => {
  return (
    <AuthorizeAdminFlowProvider>
      <AuthorizeAdminFlowMain />
    </AuthorizeAdminFlowProvider>
  )
}
